/**
 * Contract Manager API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {LoaLoasread} from '../model/loaLoasread';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class LoaService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Retrieves the collection of Loa resources.
   *
   * @param customerUuid
   * @param customerUuid2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLoaCollection(customerUuid?: string, customerUuid2?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<LoaLoasread>>;

  public getLoaCollection(customerUuid?: string, customerUuid2?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LoaLoasread>>>;

  public getLoaCollection(customerUuid?: string, customerUuid2?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LoaLoasread>>>;

  public getLoaCollection(customerUuid?: string, customerUuid2?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (customerUuid !== undefined) {
      queryParameters = queryParameters.set('customerUuid', <any>customerUuid);
    }
    if (customerUuid2) {
      customerUuid2.forEach((element) => {
        queryParameters = queryParameters.append('customerUuid[]', <any>element);
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<LoaLoasread>>(`${this.basePath}/api/loas`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves a Loa resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLoaItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<LoaLoasread>;

  public getLoaItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoaLoasread>>;

  public getLoaItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoaLoasread>>;

  public getLoaItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getLoaItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<LoaLoasread>(`${this.basePath}/api/loas/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
